import 'react-phone-input-2/lib/style.css';

import PhoneInput from 'react-phone-input-2';
import styled from '@emotion/styled';
import { Box, Flex } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';
import { themeGet } from '@styled-system/theme-get';

export const FullHeightFlex = styled(Flex)`
  min-height: 100vh;
  background-color: ${themeGet('colors.black')};
`;

export const WhiteLargeText = styled(Text)`
  color: ${themeGet('colors.white')};
`;

export const TitleWrapper = styled(Flex)`
  flex-direction: column;
  align-items: center;
  border-bottom: solid 1px;
  border-color: ${themeGet('colors.gray-600')};
  color: ${themeGet('colors.white')};
  z-index: 1;
  @media only screen and (max-height: ${themeGet('breakpoints.0')}) {
    padding: ${themeGet('space.1')};
  }
`;

export const StyledFlexWrapper = styled(Flex)`
  width: 100%;
  height: 100%;

  @media only screen and (max-width: ${themeGet('breakpoints.1')}) {
    flex-wrap: wrap;
  }
`;

export const StyledFlexCustomerInputs = styled(Flex)<{ isCustomerCFD: boolean }>`
  margin-top: 0;
  max-width: 700px;
  padding: ${themeGet('space.3')};

  @media only screen and (min-width: ${themeGet('breakpoints.1')}) {
    border-right: ${props =>
      !props.isCustomerCFD ? `solid 1px ${themeGet('colors.gray-800')(props)}` : 'none'};
  }

  @media only screen and (max-width: ${themeGet('breakpoints.1')}) {
    padding: 0 ${themeGet('space.3')};
  }
`;

export const BoxWithTopMargin = styled(Box)`
  margin-top: ${themeGet('space.4')};
  @media only screen and (max-width: ${themeGet('breakpoints.1')}) {
    margin-top: ${themeGet('space.2')};
  }

  input {
    border: 1px solid ${themeGet('colors.black')};
  }
  input.input-error {
    border: 1px solid red;
  }
`;

export const FullBoxSmallScreen = styled(Box)`
  flex: 1 0 45%;
  @media only screen and (max-width: ${themeGet('breakpoints.1')}) {
    flex: 100%;
    margin: ${themeGet('space.2')} 0 0;
  }
`;

export const StyledPhoneInput = styled(PhoneInput)`
  font-family: ${themeGet('fontFamily.sans-serif')} !important;
  input.phone-input-ele {
    width: 100%;
    height: 4.75rem;
    background-color: ${themeGet('colors.gray-800')} !important;
    color: ${themeGet('colors.white')};
    border-radius: 6px;
    padding: ${themeGet('space.3')};
    padding-left: ${themeGet('space.9')};
    outline: none;
    appearance: none;
    margin: 0;
    border: 0;
    line-height: 1;
    text-decoration: none;
    font-weight: ${themeGet('fontWeights.bold')};
    font-size: ${themeGet('fontSizes.text-xxl')};

    @media only screen and (max-width: ${themeGet('breakpoints.1')}) {
      font-size: ${themeGet('fontSizes.text-l')};
      height: 3.75rem;
    }

    &:disabled {
      background-color: ${themeGet('colors.gray-800')};
      color: ${themeGet('colors.gray-600')};
    }
  }
  .phone-country-btn {
    width: '2.5rem';
    border: 0;
    border-radius: 6px 0 0 6px;
    border-right: 1px solid #6a6a6a;
  }

  .phone-country-btn .selected-flag {
    background-color: #2f3137 !important;
    border 0;
  }
  
  .phone-dropdown::-webkit-scrollbar {
    display: none;
  }

  .phone-dropdown.country-list {
    min-width: 360px;
    min-height: 300px;
    @media only screen and (max-height: ${themeGet('breakpoints.1')}) {
      min-height: 200px;
    }
    @media only screen and (max-width: ${themeGet('breakpoints.1')}) {
      min-width: 250px;
    }
  }

  .phone-dropdown .country {
    padding: 12px;
    height: 3rem;
  }
  .phone-dropdown .search input {
    border-radius: 2px;
    width: 95%;
    height: 2.75rem;
    font-size: ${themeGet('fontSizes.text-l')};
  }
  .phone-dropdown,
  .phone-dropdown .search,
  .phone-dropdown .search input {
    background-color: #2f3137;
    color: #fff;
  }

  .phone-dropdown .search input::placeholder {
    color: #bebebe !important;
  }

  .phone-dropdown .country-name {
    font-size: ${themeGet('fontSizes.text-l')};
  }

  .country.highlight,
  .country:hover,
  .country .dial-code:hover {
    color: #000 !important;
  }

  .dial-code {
    color: #bebebe !important;
  }
  .country.highlight .dial-code,
  .country:hover .dial-code {
    color: #6a6a6a !important;
  }
`;

export const StyledHeader = styled(Text)`
  font-size: ${themeGet('fontSizes.text-xxl')};

  @media only screen and (max-width: ${themeGet('breakpoints.1')}) {
    font-size: ${themeGet('fontSizes.text-xl')};
  }
`;
